import React, { useState, useCallback, useEffect } from "react";
import { useLanguage } from "../context/LanguageContext";
import useReveal from "../hooks/useReveal";
import Header from "../components/Header";
import Hero from "../components/Hero";
import About from "../components/About";
import AudienceSection from "../components/AudienceSection";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

const Home = () => {
  const { lang } = useLanguage();
  const [mode, setMode] = useState("company");
  const [roleSignal, setRoleSignal] = useState(null);
  const [subjectSignal, setSubjectSignal] = useState("");

  useReveal([lang, mode]);

  const scrollTo = useCallback((id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  // Handle "Apply" intent coming from the dedicated Jobs page
  useEffect(() => {
    const raw = sessionStorage.getItem("pss_apply");
    if (raw) {
      try {
        const data = JSON.parse(raw);
        setRoleSignal(data.role || "worker");
        setSubjectSignal(data.subject || "");
      } catch (e) {
        /* ignore */
      }
      sessionStorage.removeItem("pss_apply");
      setTimeout(() => scrollTo("contact"), 350);
    }
  }, [scrollTo]);

  const goCompany = () => {
    setMode("company");
    scrollTo("audience");
  };
  const goWorker = () => {
    setMode("worker");
    scrollTo("audience");
  };

  const inquireAsCompany = () => {
    setRoleSignal("company");
    setSubjectSignal("");
    scrollTo("contact");
  };

  const applyToJob = (jobTitle) => {
    setRoleSignal("worker");
    setSubjectSignal(jobTitle);
    scrollTo("contact");
  };

  return (
    <div className="App">
      <Header />
      <Hero onCompany={goCompany} onWorker={goWorker} />
      <About />
      <AudienceSection
        mode={mode}
        setMode={setMode}
        onInquiry={inquireAsCompany}
        onApply={applyToJob}
      />
      <Contact roleSignal={roleSignal} subjectSignal={subjectSignal} />
      <Footer />
    </div>
  );
};

export default Home;
